export default el => {
  el.style.height = 0
  el.style.height = Math.max(el.scrollHeight, 50) + "px"
}
